<template>
  <section>
    <v-card style="width: 1000px" height="500px" class="mx-auto">
      <v-card-text class="text-center">
        <h1 class="my-16">{{ name }}</h1>
      </v-card-text>
      <v-card-text class="text-center">
        <p class="">{{ description }}</p>
      </v-card-text>

      <v-card-text class="text-center">
        <h4 class="my-10">{{ signature }}</h4>
      </v-card-text>
    </v-card>
    <v-card style="width: 1000px" class="mx-auto mt-10">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          small
          class="my-4 mx-4"
          @click.stop="_save()"
          :ripple="false"
          elevation="0"
        >
          Xадгалаx {{ nochange }}
        </v-btn>
      </v-card-actions>
      <v-card-text class="text-center">
        <v-row>
          <v-col cols="10"><v-text-field
          v-model.trim="name"
          label="Тодорxойлолтын нэр"
        ></v-text-field></v-col>
        <v-col cols="2">
          <v-text-field
          v-model.trim="todCode"
          label="Тодорxойлолтын код"
        ></v-text-field>
        </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-textarea
              filled
              v-model.trim="description"
              label="Агуулга оруулаx"
            />
          </v-col>
        </v-row>
        <v-text-field
          v-model.trim="signature"
          label="Гарын үсэг"
        ></v-text-field>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  components: {},
  data: () => ({
    value: "",
    nochange: true,
    name: null,
    description: null,
    signature: null,
    item: null,
    todCode:null,
  }),
  watch: {},
  props: {
    itemRefPath: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    fb.db
      .doc(this.itemRefPath)
      .get()
      .then((doc) => {
        this.item = doc.data();
        this.item.ref = doc.ref;
        this.item.id = doc.id;
        this.name = this.item.name;
        this.description = this.item.description;
        this.signature = this.item.signature;
        this.todCode = this.item.code
      });
  },
  mounted() {
    this.nochange = true;
  },
  watch: {
    name: function () {
      this.nochange = false;
    },
    description: function () {
      this.nochange = false;
    },
    signature: function () {
      this.nochange = false;
    },
    todCode: function () {
      this.nochange = false;
    },
  },
  methods: {
    _save() {
      this.item.ref
        .update({
          name: this.name ? this.name : null,
          description: this.description ? this.description : null,
          signature: this.signature ? this.signature : null,
          code: this.todCode ? this.todCode : null,
        })
        .then(() => {
          this.nochange = true;
        });
    },
  },
};
</script>
